import { DEFAULT_PAGE, getPageOrDefault } from '@is24at/react-pagination';

const robots = ({ searchQuery = {} } = {}) =>
  `${
    DEFAULT_PAGE === getPageOrDefault(searchQuery) ? 'index' : 'noindex'
  }, follow`;

export default robots;
